/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropDiscordChannel
 */
export interface DropDiscordChannel {
    /**
     * 
     * @type {string}
     * @memberof DropDiscordChannel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropDiscordChannel
     */
    name: string;
}

/**
 * Check if a given object implements the DropDiscordChannel interface.
 */
export function instanceOfDropDiscordChannel(value: object): value is DropDiscordChannel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DropDiscordChannelFromJSON(json: any): DropDiscordChannel {
    return DropDiscordChannelFromJSONTyped(json, false);
}

export function DropDiscordChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropDiscordChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function DropDiscordChannelToJSON(json: any): DropDiscordChannel {
    return DropDiscordChannelToJSONTyped(json, false);
}

export function DropDiscordChannelToJSONTyped(value?: DropDiscordChannel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

